import { createFileRoute } from "@tanstack/react-router";
import CommunityLayout from "lib/components/builders/communities/CommunityLayout";
import MapView from "lib/components/builders/communities/map/MapView";
import withAuthentication from "../../../../../../components/withAuthentication";

function MapPage() {
  return (
    <CommunityLayout currentPage="map">
      <MapView />
    </CommunityLayout>
  );
}

export const Route = createFileRoute("/builders/$builder_id/locations/$location_id/map/")({
  component: withAuthentication(MapPage, { permissions: ["VIEW_COMMUNITY_MAP"] }),
});
